import { isEmpty, isNumber } from "lodash";
import { Fragment, useState } from "react";
import { useContextSelector } from "use-context-selector";
import BetSlipContext from "../../../context/BetSlipContext";
import { formatWithCommas } from "../../../Utils/Toast";
import BetSlipSky from "./BetSlipSky";
import { useFancyLogic } from "../../useLogic/useFancyLogic";

const FancySky = ({
  fancy,
  detail,
  profileData,
  position,
  favouriteList,
  fancyHeader,
  setFancyModal,
}) => {
  const [showLimit, setShowLimit] = useState("");
  const [fancyHeaderKey, setFancyHeaderKey] = useState("All");
  const betSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betSlipObject;
  });

  const showBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.showBetDialog;
  });
  const { data, localLimit, handelChange, mergeAndCalculate } = useFancyLogic({
    fancy,
    detail,
    profileData,
    favouriteList,
    fancyHeaderKey,
  });

  return (
    <Fragment>
      {" "}
      <div
        id="fancyBetTabWrap"
        className="fancy_bet_tab-wrap ps ps--theme_default ps--active-x"
        data-ps-id="b3ea9fe0-3f83-a65e-1914-694a272b19aa"
      >
        <ul className="special_bets-tab">
          {fancyHeader?.map((res, index) => {
            return (
              <li
                onClick={() => {
                  setFancyHeaderKey(res?.type);
                }}
                className={fancyHeaderKey == res?.type ? "select" : ""}
              >
                <div className="special_bets-tab-a">{res?.name}</div>
              </li>
            );
          })}
        </ul>
      </div>
      {data?.length == 0 ? (
        <div id="noGameWrap" className="bets-wrap">
          <p className="no-game">
            Fancybet market will be available after Event at In-Play
          </p>
        </div>
      ) : (
        <Fragment>
          <div id="fancyBetField" className="bets-wrap fancy-bet">
            <dl className="bets-selections-head">
              <dt />
              <dd className="mode-land" />
              <dd className="mode-land" />
              <dd>No</dd>
              <dd>Yes</dd>
              <dd className="mode-land" />
              <dd className="mode-land" />
            </dl>
          </div>
          <div id="fancyBetTag">
            {data?.map((item, index) => {
              if (
                item?.odds?.ms == 4 ||
                item?.odds?.rt?.length == 0 ||
                item?.odds?.ms == 2 ||
                isEmpty(item?.odds?.rt)
              ) {
                return null;
              } else {
                let findPosition = position?.find((res) => {
                  return res?.selectionId == item?.selectionId;
                });
                let oldPosition = !isEmpty(findPosition)
                  ? findPosition?.position
                  : "";

                let newPosition = "";
                if (oldPosition && position) {
                  let oldPositionData = findPosition || [];

                  if (betSlipObject?.teamName === item?.name && showBetDialog) {
                    betSlipObject.betType = betSlipObject?.object?.ib
                      ? "Yes"
                      : "No";

                    newPosition =
                      oldPositionData && oldPositionData?.betRunPosition
                        ? mergeAndCalculate(betSlipObject, oldPositionData)
                        : 0;
                  }
                } else {
                  if (betSlipObject?.teamName === item?.name && showBetDialog) {
                    if (betSlipObject?.object?.ib) {
                      if (Math.abs(item?.position) > 0) {
                        let backLoss =
                          Number(betSlipObject?.bidPrice) +
                          Number(item?.position);
                        newPosition = backLoss;
                      } else {
                        let backLoss = Number(betSlipObject?.bidPrice);
                        newPosition = backLoss;
                      }
                    } else {
                      if (Math.abs(item?.position) > 0) {
                        let backProfit =
                          (betSlipObject?.bidPrice *
                            betSlipObject?.object?.pt) /
                          100;
                        newPosition =
                          Number(backProfit) + Number(item.position);
                      } else {
                        let backProfit =
                          (betSlipObject?.bidPrice *
                            betSlipObject?.object?.pt) /
                          100;
                        newPosition = backProfit;
                      }
                    }
                  }
                }

                return (
                  <Fragment>
                    <div
                      id="fancyBetMarket_2552211"
                      className="bets-wrap fancy-bet"
                    >
                      <h5>
                        <span id="marketName"> {item?.name}</span>
                        <div
                          onClick={() => setShowLimit(item?.selectionId)}
                          id="open-fancy_info"
                          className="btn-fancy_info"
                        >
                          fancybet info
                        </div>
                        {showLimit == item?.selectionId && (
                          <div
                            style={{
                              display:
                                showLimit == item?.selectionId
                                  ? "flex"
                                  : "none",
                            }}
                            id="fancy_popup2"
                            className="fancy_info-popup"
                          >
                            <dl>
                              <dt>Min / Max</dt>
                              <dd id="minMax">
                                {" "}
                                {formatWithCommas(localLimit?.minAmount)} /{" "}
                                {formatWithCommas(localLimit?.maxAmount)}
                              </dd>
                            </dl>
                         
                            <div
                              onClick={() => setShowLimit("")}
                           
                              id="close-fancy_info"
                              className="close"
                            >
                              Close
                            </div>
                          </div>
                        )}
                      </h5>
                      <dl className="bets-selections">
                        <dt className="line_market-selection">
                          <dl className="tips">
                            <dt>
                              {isNumber(oldPosition) &&
                                Math.abs(item?.position) > 0 && (
                                  <span
                                    id="before"
                                    className={
                                      item?.position > 0 ? "win" : "lose"
                                    }
                                  >
                                    {isNumber(oldPosition)
                                      ? `( ${Math?.abs(item?.position).toFixed(
                                          2
                                        )} )`
                                      : ""}
                                  </span>
                                )}
                              {betSlipObject?.teamName === item?.name &&
                                Math.abs(newPosition) >= 0 && (
                                  <span
                                    id="after"
                                    className={`to-${
                                      newPosition > 0 ? "win" : "lose"
                                    }`}
                                  >
                                    {`( ${Math.abs(newPosition).toFixed(2)} )`}
                                  </span>
                                )}
                            </dt>
                          </dl>
                          {!isEmpty(findPosition) && (
                            <div
                              onClick={() =>
                                setFancyModal({
                                  status: true,
                                  object: {
                                    ...item,
                                    match: detail?.eventName,
                                    prevPosition: isNumber(oldPosition),
                                  },
                                })
                              }
                              style={{
                                color: "#1e1e1e",
                                padding: "1vw",
                                flexDirection: "column",
                                justifyContent: "center",
                              }}
                              id="fancyBetBookBtn"
                              className="btn-book"
                            >
                              Book
                            </div>
                          )}
                        </dt>
                        {(item?.odds?.ms == 9 ||
                          item?.odds?.ms == 2 ||
                          item?.odds?.ms == 3 ||
                          item?.odds?.ms == 4) && (
                          <dd id="suspend" className="suspend-fancy">
                            <p id="info">Suspend</p>
                          </dd>
                        )}

                        <dd
                          title={
                            item?.odds?.rt?.length > 0
                              ? item?.odds?.rt[0]?.rt
                              : ""
                          }
                          id={"lay_odds_fancy_" + index}
                          onClick={(e) => {
                            {
                              handelChange(
                                item?.odds?.rt[0],
                                "No",
                                item?.name,
                                item,
                                e
                              );
                            }
                          }}
                        >
                          <div
                            className={`lay-1 lay-back-block ${
                              betSlipObject?.teamName == item?.name &&
                              betSlipObject?.odds == item?.odds?.rt[0]?.rt &&
                              showBetDialog &&
                              betSlipObject?.betType == "No"
                                ? "select"
                                : ""
                            } ${
                              Number(
                                document.getElementById(
                                  "lay_odds_fancy_" + index
                                )?.title
                              ) !== item?.odds?.rt[0]?.rt
                                ? "spark"
                                : ""
                            }`}
                          >
                            {item?.odds?.rt[0]?.rt || ""}
                            <span> {item?.odds?.rt[0]?.pt || ""}</span>
                          </div>
                        </dd>
                        <dd
                          title={
                            item?.odds?.rt?.length > 0
                              ? item?.odds?.rt[1]?.rt
                              : ""
                          }
                          id={"back_odds_fancy_" + index}
                          onClick={(e) => {
                            {
                              handelChange(
                                item?.odds?.rt[1],
                                "Yes",
                                item?.name,
                                item,
                                e
                              );
                            }
                          }}
                        >
                          <div
                            className={`back-1 lay-back-block ${
                              Number(
                                document.getElementById(
                                  "back_odds_fancy_" + index
                                )?.title
                              ) !== item?.odds?.rt[1]?.rt
                                ? "spark"
                                : ""
                            } ${
                              betSlipObject?.teamName == item?.name &&
                              betSlipObject?.odds == item?.odds?.rt[1]?.rt &&
                              showBetDialog &&
                              betSlipObject?.betType == "Yes"
                                ? "select"
                                : ""
                            }`}
                          >
                            {item?.odds?.rt[1]?.rt || ""}
                            <span> {item?.odds?.rt[1]?.pt || ""}</span>
                          </div>
                        </dd>
                        <dd className="mode-land" />
                        <dd className="mode-land" />
                      </dl>
                    </div>{" "}
                    {showBetDialog &&
                      betSlipObject?.playType == "fancy" &&
                      detail?.marketId == betSlipObject?.object?.marketId &&
                      betSlipObject?.teamName == item?.name && <BetSlipSky />}
                  </Fragment>
                );
              }
            })}
          </div>{" "}
        </Fragment>
      )}
    </Fragment>
  );
};

export default FancySky;
